// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acs-journal-list[data-v-54ec531a] {
  text-align: left;
  overflow-y: hidden;
  flex: 1 1;
  margin-bottom: 0 !important;
}
.acs-journal-list .item[data-v-54ec531a] {
  color: gray;
  padding: 0 0 0 5px;
}
.acs-journal-list .item:last-child .center-right[class*="center-right"][data-v-54ec531a] {
  border-bottom: none;
}
.acs-journal-list .item .wrapper[data-v-54ec531a] {
  display: flex;
  height: 68px;
  align-items: center;
}
.acs-journal-list .item .wrapper > div[data-v-54ec531a] {
  height: 100%;
}
.acs-journal-list .item .wrapper .left-side[data-v-54ec531a] {
  color: gray;
  display: flex;
  flex-direction: row;
  margin-right: 5px;
}
.acs-journal-list .item .wrapper .left-side .icon[data-v-54ec531a] {
  color: white;
  cursor: default !important ;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  background-color: var(--icon-bgcolor);
  margin: auto 5px;
}
.acs-journal-list .item .wrapper .left-side .icon i[data-v-54ec531a] {
  margin: auto;
  font-size: 1.6em;
  cursor: default;
}
.acs-journal-list .item .wrapper .center-right[data-v-54ec531a] {
  border-bottom: 1px solid var(--asc-item-border-bottom);
  display: flex;
  width: 100%;
  margin-left: 5px;
}
.acs-journal-list .item .wrapper .center-right.empty[data-v-54ec531a] {
  border-bottom: none;
}
.acs-journal-list .item .wrapper .center-right .center[data-v-54ec531a] {
  margin: auto 0;
  flex: 1 1;
}
.acs-journal-list .item .wrapper .center-right .center .desc[data-v-54ec531a] {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  cursor: default;
  padding-left: 5px;
}
.acs-journal-list .item .wrapper .center-right .center .desc .status[data-v-54ec531a] {
  margin: auto 0;
  font-weight: 600;
  color: var(--message-grey-color);
}
.acs-journal-list .item .wrapper .center-right .center .desc .text[data-v-54ec531a] {
  margin: auto 0;
  font-size: 0.8em;
  color: var(--custom-textarea-color);
}
.acs-journal-list .item .wrapper .center-right .center .desc .date[data-v-54ec531a] {
  color: var(--placeholder-color);
}
.acs-journal-list .item .wrapper .center-right .center .desc .comment[data-v-54ec531a] {
  font-size: 0.8em;
}
.acs-journal-list .item .wrapper .center-right .right[data-v-54ec531a] {
  cursor: pointer;
  margin: auto 0 auto auto;
}
.acs-journal-list .edit[data-v-54ec531a] {
  text-align: left;
}
.acs-journal-list .edit .space-top[data-v-54ec531a] {
  margin-top: 10px;
}
.acs-journal-list .edit .label[data-v-54ec531a] {
  font-size: 20px;
  color: var(--custom-textarea-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/acs/AcsJournalList.vue"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sDAAsD;EACtD,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mCAAmC;AACrC","sourcesContent":[".acs-journal-list[data-v-54ec531a] {\n  text-align: left;\n  overflow-y: hidden;\n  flex: 1 1;\n  margin-bottom: 0 !important;\n}\n.acs-journal-list .item[data-v-54ec531a] {\n  color: gray;\n  padding: 0 0 0 5px;\n}\n.acs-journal-list .item:last-child .center-right[class*=\"center-right\"][data-v-54ec531a] {\n  border-bottom: none;\n}\n.acs-journal-list .item .wrapper[data-v-54ec531a] {\n  display: flex;\n  height: 68px;\n  align-items: center;\n}\n.acs-journal-list .item .wrapper > div[data-v-54ec531a] {\n  height: 100%;\n}\n.acs-journal-list .item .wrapper .left-side[data-v-54ec531a] {\n  color: gray;\n  display: flex;\n  flex-direction: row;\n  margin-right: 5px;\n}\n.acs-journal-list .item .wrapper .left-side .icon[data-v-54ec531a] {\n  color: white;\n  cursor: default !important ;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  background-color: var(--icon-bgcolor);\n  margin: auto 5px;\n}\n.acs-journal-list .item .wrapper .left-side .icon i[data-v-54ec531a] {\n  margin: auto;\n  font-size: 1.6em;\n  cursor: default;\n}\n.acs-journal-list .item .wrapper .center-right[data-v-54ec531a] {\n  border-bottom: 1px solid var(--asc-item-border-bottom);\n  display: flex;\n  width: 100%;\n  margin-left: 5px;\n}\n.acs-journal-list .item .wrapper .center-right.empty[data-v-54ec531a] {\n  border-bottom: none;\n}\n.acs-journal-list .item .wrapper .center-right .center[data-v-54ec531a] {\n  margin: auto 0;\n  flex: 1 1;\n}\n.acs-journal-list .item .wrapper .center-right .center .desc[data-v-54ec531a] {\n  display: flex;\n  flex: 1 1;\n  flex-direction: column;\n  cursor: default;\n  padding-left: 5px;\n}\n.acs-journal-list .item .wrapper .center-right .center .desc .status[data-v-54ec531a] {\n  margin: auto 0;\n  font-weight: 600;\n  color: var(--message-grey-color);\n}\n.acs-journal-list .item .wrapper .center-right .center .desc .text[data-v-54ec531a] {\n  margin: auto 0;\n  font-size: 0.8em;\n  color: var(--custom-textarea-color);\n}\n.acs-journal-list .item .wrapper .center-right .center .desc .date[data-v-54ec531a] {\n  color: var(--placeholder-color);\n}\n.acs-journal-list .item .wrapper .center-right .center .desc .comment[data-v-54ec531a] {\n  font-size: 0.8em;\n}\n.acs-journal-list .item .wrapper .center-right .right[data-v-54ec531a] {\n  cursor: pointer;\n  margin: auto 0 auto auto;\n}\n.acs-journal-list .edit[data-v-54ec531a] {\n  text-align: left;\n}\n.acs-journal-list .edit .space-top[data-v-54ec531a] {\n  margin-top: 10px;\n}\n.acs-journal-list .edit .label[data-v-54ec531a] {\n  font-size: 20px;\n  color: var(--custom-textarea-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
